// Pay Now for a CRM 2.0 Shortlisted card (M3-F2). Same flow as today's Home/Allotment.jsx Pay Now
// (consent gate → booking amount pop-up → payment link or Razorpay); copied here so today's
// Allotment.jsx stays untouched for old-flow bookings.
//   const { payNow, payModals } = usePayNow(allotment); <Button clicked={payNow} /> {payModals}
import React, { useEffect, useState } from "react";
import AllotmentPayment from "../../../Modals/AllotmentPayment/AllotmentPayment";
import PaymentGatewaySelection from "../../../Modals/PaymentGateway/PaymentGatewaySelection";
import usePaymentConsent, { allotmentConsentSummary } from "../../../Modals/PaymentConsent/usePaymentConsent";
import { CONSENT_TYPES } from "../../../Services/Consent";
import { createPaymentOrder, getPaymentLinkMode, getPyamentLink, sdrPaymentMode } from "../../../Services/Allotment";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { errorTost, successTost } from "../../../Services/Toast";

export default function usePayNow(allotment) {
	const { requireConsent, consentModal } = usePaymentConsent();
	const [allotmentDetails, setAllotmentDetails] = useState({});
	const [pendingTransaction, setPendingTransaction] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [openPay, setOpenPay] = useState(false);
	const [openGateway, setOpenGateway] = useState(false);
	const [payableAmount, setPayableAmount] = useState(0);

	useEffect(() => {
		if (Object.keys(allotmentDetails).length > 0 && showModal) {
			const pending = (allotmentDetails.AllotmentTransactions || []).filter((t) => t.status === "pending");
			if (pending.length > 0) setPendingTransaction([pending[0]]);
			else setOpenPay(true);
		}
	}, [allotmentDetails, showModal]);
	useEffect(() => {
		if (pendingTransaction.length > 0) setOpenPay(true);
	}, [pendingTransaction]);

	const close = () => {
		setPendingTransaction([]);
		setAllotmentDetails({});
		setShowModal(false);
		setOpenPay(false);
	};

	const handlePayment = async (amount) => {
		presentLoader();
		try {
			const mode = await sdrPaymentMode();
			if (mode.data[0].useLinkInCustomerAppForAllotment) {
				const create = await getPaymentLinkMode(allotmentDetails, amount);
				if (!create.data.success) {
					dismissLoader();
					return errorTost(create.data.message);
				}
				const link = await getPyamentLink(create.data.paymentLinkId);
				dismissLoader();
				if (!link.data.success) return errorTost("Could not create order!");
				close();
				successTost("Payment link sent on registered mobile number!");
				const anchor = document.createElement("a");
				anchor.href = link.data.link;
				anchor.target = "_blank";
				anchor.click();
				return;
			}
			const order = await createPaymentOrder({
				amount,
				type: "Allotment",
				transactionObj: {
					amount,
					transactionType: allotmentDetails.pricingType,
					modeOfPayment: "Razorpay-Customer Portal",
					allotmentPaymentId: allotmentDetails.allotmentPaymentId,
					unitId: allotmentDetails?.unitId?.unitId,
					inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId,
					leadId: allotmentDetails.leadId.leadId,
					status: "pending",
				},
			});
			dismissLoader();
			if (!order?.data?.success) return errorTost("Couldn't create order! please try again later");
			new window.Razorpay({
				key: process.env.REACT_APP_RAZOR_PAY_KEY,
				amount: amount * 100,
				currency: "INR",
				name: "VJ Developers",
				description: "Payment for booking " + allotmentDetails?.allotmentPaymentId, // M6-F9 (DC-75) wording
				order_id: order.data.id,
				handler: (response) => console.log("[crm2][payNow] razorpay response", response),
			}).open();
		} catch (err) {
			console.error("[crm2][payNow] payment failed", err);
			dismissLoader();
			errorTost("Payment Failed! Please try again Later");
		}
	};

	const allotmentPaymentResponse = (value) => {
		if (value && value > 0) {
			handlePayment(value);
			setOpenPay(false);
		}
	};

	const payNow = () =>
		requireConsent(
			CONSENT_TYPES.ALLOTMENT,
			() => {
				setOpenPay(true);
				setShowModal(true);
				setAllotmentDetails(allotment);
			},
			{ summary: allotmentConsentSummary(allotment), allotmentPaymentId: allotment.allotmentPaymentId },
		);

	const payModals = (
		<>
			{consentModal}
			{openPay && (
				<AllotmentPayment
					allotmentDetails={allotmentDetails}
					pendingTransaction={pendingTransaction}
					setPendingTransaction={setPendingTransaction}
					setAllotmentDetails={setAllotmentDetails}
					open={openPay}
					allotmentPaymentResponse={allotmentPaymentResponse}
					setOpenPaymentGatewaySelectionModal={setOpenGateway}
					payableAmount={payableAmount}
					setPayableAmount={setPayableAmount}
					handleClose={close}
				/>
			)}
			{openGateway && (
				<PaymentGatewaySelection
					open={openGateway}
					onClose={() => setOpenGateway(false)}
					allotmentPaymentResponse={allotmentPaymentResponse}
					payableAmount={payableAmount}
					allotmentDetails={allotmentDetails}
					type={"allotment"}
				/>
			)}
		</>
	);
	return { payNow, payModals };
}
